import React, { useCallback, useMemo, useRef } from "react";
import { useAppContext } from "../../hooks/useAppContext";
import { PhotoSource } from "../photo-source";

export const localPhotoStoreBase = {
	storeType: eXpress.core.StoreType.Local,
	connectedUserName: undefined,
	id: "local",
	isConnected: true,
	hasAlbumAccess: true,
	name: "my device",
} satisfies Partial<eXpress.core.IPhotoStore>;

export interface ILocalPhotosImport {
	photoStore: eXpress.core.IPhotoStore;
	files: File[];
}

export const PhotoSourceLocal = ({
	accept,
	name,
	onChange,
}: {
	accept?: string;
	name: string;
	onChange: (selection: ILocalPhotosImport) => void;
}) => {
	const { googleAnalytics } = useAppContext();
	const localPhotoStore = useMemo(
		() => ({
			...localPhotoStoreBase,
			name,
		}),
		[name],
	);

	const inputRef = useRef<HTMLInputElement>(null);

	/** Open the file dialog */
	const onIconClick = useCallback(() => {
		if (!inputRef.current) return;
		inputRef.current.focus();
		inputRef.current.click();
		googleAnalytics.trackEventToGa({
			trackingAction: "PhotoSourceMyDevice",
		});
	}, [inputRef, googleAnalytics]);

	/** New files are selected in the file dialog */
	const onFileChange = useCallback<React.ChangeEventHandler<HTMLInputElement>>(
		(e) => {
			onChange({
				photoStore: localPhotoStore,
				files: Array.from(e.target?.files || []),
			});
		},
		[onChange, localPhotoStore],
	);

	return (
		<>
			<input
				ref={inputRef}
				type="file"
				style={{ display: "none" }}
				accept={accept}
				multiple
				onChange={onFileChange}
			/>
			<PhotoSource {...localPhotoStore} onClick={onIconClick} />
		</>
	);
};
